<template>
  <router-view/>
</template>

<style lang="scss">
 @import "assets/com_scss/app.scss";
</style>
